/**
 * Klavye/fare olaylarını host'a UDP (WsBridge) üzerinden gönderir.
 * Event wire format (opcode + payload):
 *   0 MouseMove    : x:i32 BE, y:i32 BE                      (9 byte)
 *   1 MouseButton  : button:u8, pressed:u8                   (3 byte)
 *   2 MouseWheel   : dx:i32 BE, dy:i32 BE                    (9 byte)
 *   3 KeyDown      : vk:u16 BE                               (3 byte)
 *   4 KeyUp        : vk:u16 BE                               (3 byte)
 *
 * PacketHeader(11) + event payload, channel = Input (3).
 */
import { Channel, PacketType, buildPacket, } from './packet-header';
/** Windows Virtual-Key kodları — Host SendInput ile birebir. */
export const VK = {
    Backspace: 0x08, Tab: 0x09, Enter: 0x0D, Shift: 0x10, Control: 0x11,
    Alt: 0x12, CapsLock: 0x14, Escape: 0x1B, Space: 0x20,
    PageUp: 0x21, PageDown: 0x22, End: 0x23, Home: 0x24,
    ArrowLeft: 0x25, ArrowUp: 0x26, ArrowRight: 0x27, ArrowDown: 0x28,
    Insert: 0x2D, Delete: 0x2E,
    F1: 0x70, F2: 0x71, F3: 0x72, F4: 0x73, F5: 0x74, F6: 0x75,
    F7: 0x76, F8: 0x77, F9: 0x78, F10: 0x79, F11: 0x7A, F12: 0x7B,
    Meta: 0x5B, // Windows key
};
export class InputSender {
    bridge;
    seq = 1;
    sessionId24;
    /**
     * @param sessionId24 Backend'den gelen relay session ID (24-bit). Packet
     * header'ın 1-3. byte'ına big-endian yazılır. Faz V öncesi naive hash
     * yaklaşımı (sessionIdToUint24) değişti — backend authoritative.
     */
    constructor(bridge, sessionId24) {
        this.bridge = bridge;
        this.sessionId24 = sessionId24 & 0x00ffffff;
    }
    mouseMove(x, y) {
        const p = new Uint8Array(9);
        p[0] = 0; // opcode MouseMove
        this.writeI32BE(p, 1, x);
        this.writeI32BE(p, 5, y);
        this.send(p);
    }
    mouseButton(button, pressed) {
        const p = new Uint8Array(3);
        p[0] = 1;
        p[1] = button & 0xff;
        p[2] = pressed ? 1 : 0;
        this.send(p);
    }
    mouseWheel(dx, dy) {
        const p = new Uint8Array(9);
        p[0] = 2;
        this.writeI32BE(p, 1, Math.trunc(dx));
        this.writeI32BE(p, 5, Math.trunc(dy));
        this.send(p);
    }
    keyDown(vk) {
        const p = new Uint8Array(3);
        p[0] = 3;
        p[1] = (vk >> 8) & 0xff;
        p[2] = vk & 0xff;
        this.send(p);
    }
    keyUp(vk) {
        const p = new Uint8Array(3);
        p[0] = 4;
        p[1] = (vk >> 8) & 0xff;
        p[2] = vk & 0xff;
        this.send(p);
    }
    /** Browser KeyboardEvent → Windows VK çevirici. */
    keyEventToVk(e) {
        if (VK[e.key])
            return VK[e.key];
        if (e.key.length === 1) {
            const c = e.key.toUpperCase().charCodeAt(0);
            // A-Z (0x41-0x5A), 0-9 (0x30-0x39)
            if ((c >= 0x41 && c <= 0x5A) || (c >= 0x30 && c <= 0x39))
                return c;
        }
        // KeyA / Digit1 gibi code'lar fallback
        if (e.code.startsWith('Key') && e.code.length === 4) {
            return e.code.charCodeAt(3);
        }
        if (e.code.startsWith('Digit') && e.code.length === 6) {
            return e.code.charCodeAt(5);
        }
        return null;
    }
    send(payload) {
        const packet = buildPacket({
            version: 0,
            packetType: PacketType.Data,
            flags: 0,
            sessionId: this.sessionId24,
            sequence: this.seq++,
            channel: Channel.Input,
        }, payload);
        this.bridge.send(packet);
    }
    writeI32BE(out, off, v) {
        const u = (v | 0) >>> 0;
        out[off + 0] = (u >>> 24) & 0xff;
        out[off + 1] = (u >>> 16) & 0xff;
        out[off + 2] = (u >>> 8) & 0xff;
        out[off + 3] = u & 0xff;
    }
}
